export const link = {
  mr: 3,
  display: "inline-flex",
  alignItems: "center",

  svg: {
    mr: 1,
  },

  "&:hover": {
    textDecoration: "none",
  },
};
